import * as React from 'react';
import { CustomButton, ButtonType } from 'soprasteria-ui-library';
import { IStandardPhrase } from '../../models/IStandardPhrase';
import { StandardPhraseSelectionTable } from './StandardPhraseSelectionTable';
import { StandardPhraseSelectionForm } from './StandardPhraseSelectionForm';
import { IPage } from '../../models/IPage';
import { DecisionForm } from "./DecisionForm";

interface IStandardPhraseSelection {
    standardPhrases: IStandardPhrase[] | undefined;
    standardPhraseFeature: string;
    changeErrorMessage: (message: string) => void;
    changeSuccessMessage: (message: string) => void;
    getStandardPhrases: (page: IPage) => void;
    saveForm: (data: any) => void;
    submitForm: (data: any) => void;
    isSubmittingForm: boolean;
    standardPhraseTableHeaderExtraInfo?: string;
    additionalFormInputs?: React.ReactNode;
    showStandardPhraseTable: boolean;
    setShowStandardPhraseTable: React.Dispatch<React.SetStateAction<boolean>>;
    defaultValue?: string;
    isRequired: boolean;
}

export const StandardPhraseSelection: React.FunctionComponent<IStandardPhraseSelection> = ({
    standardPhrases,
    standardPhraseFeature,
    changeSuccessMessage,
    changeErrorMessage,
    getStandardPhrases,
    children,
    saveForm,
    submitForm,
    isSubmittingForm,
    standardPhraseTableHeaderExtraInfo,
    additionalFormInputs,
    showStandardPhraseTable,
    setShowStandardPhraseTable,
    defaultValue,
    isRequired }) => {

    const [selectedStandardPhraseText, setSelectedStandardPhraseText] = React.useState<string>();
    const [selectedStandardPhrase, setSelectedStandardPhrase] = React.useState<IStandardPhrase>();

    return (
        <section className="row">
            <>
                <div className={`${showStandardPhraseTable ? "" : "d-none"} col-6`}>
                    {children}
                    <DecisionForm
                        selectedStandardPhraseText={selectedStandardPhraseText}
                        saveForm={saveForm}
                        submitForm={submitForm}
                        isSubmittingForm={isSubmittingForm}
                        setSelectedStandardPhraseText={setSelectedStandardPhraseText}
                        additionalFormInputs={additionalFormInputs}
                        defaultValue={defaultValue}
                        isRequired={isRequired} />
                </div>
                <div className={`${showStandardPhraseTable ? "" : "d-none"} col-6 border-left`}>
                    <div className="panel text-right">
                        <CustomButton buttonType={ButtonType.create} buttonText="Skapa standardfras" onClick={() => { setShowStandardPhraseTable(false); setSelectedStandardPhrase(undefined); }} />
                    </div>
                    <StandardPhraseSelectionTable
                        standardPhraseRequestUrl={standardPhraseFeature}
                        standardPhrases={standardPhrases}
                        setSelectedStandardPhrase={setSelectedStandardPhrase}
                        setSelectedStandardPhraseText={setSelectedStandardPhraseText}
                        selectedStandardPhraseText={selectedStandardPhraseText}
                        setShowStandardPhraseTable={setShowStandardPhraseTable}
                        standardPhraseTableHeaderExtraInfo={standardPhraseTableHeaderExtraInfo}
                        changeErrorMessage={changeErrorMessage}
                        changeSuccessMessage={changeSuccessMessage}
                        getStandardPhrases={getStandardPhrases}
                    />
                </div>
            </>
            {
                showStandardPhraseTable ?
                    null
                    :
                    <div className="col-12">
                        <StandardPhraseSelectionForm
                            selectedStandardPhrase={selectedStandardPhrase}
                            standardPhraseRequestUrl={standardPhraseFeature}
                            changeErrorMessage={changeErrorMessage}
                            changeSuccessMessage={changeSuccessMessage}
                            setShowStandardPhraseTable={setShowStandardPhraseTable}
                            getStandardPhrases={getStandardPhrases}
                        />
                    </div>
            }
        </section>
    )

}